<template>
  <div class="index">
    <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
      <el-breadcrumb-item :to="{ path: '/admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item><a href="/admin">代理商</a></el-breadcrumb-item>
    </el-breadcrumb>
<!--    <el-card>-->
<!--      <div id="main" style="width: 600px; height: 400px"></div>-->
<!--    </el-card>-->
    <el-row>
      <el-col :span="8">
        <el-card class="box-card">
          <div class="text item text-direction-center" >
            代理商数量

            <p v-if="result.data">
                <el-tag type="success" size="medium" effect="dark">{{ result.data.agent_user_count }}</el-tag>

            </p>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card">
          <div class="text item text-direction-center" >
            销售订单
            <p v-if="result.data">
                <el-tag type="success" size="medium" effect="dark">{{ result.data.order_count }}</el-tag>
                </p>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card">
          <div class="text item text-direction-center">
            提现申请

            <p v-if="result.data">
                <el-tag type="success" size="medium" effect="dark">{{ result.data.withdrawal_count }}</el-tag>
            </p>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8">
        <el-card class="box-card">
          <div class="text item text-direction-center">
            售后订单
            <p v-if="result.data">
                <el-tag type="success" size="medium" effect="dark">{{ result.data.agent_orders_service_count }}</el-tag>
                </p>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card">
          <div class="text item text-direction-center">
            待结算订单数
            <p v-if="result.data">
                <el-tag type="success" size="medium" effect="dark">{{ result.data.order_no_count }}</el-tag>
              </p>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card">
          <div class="text item text-direction-center">
            待结算利润

            <p v-if="result.data">
                <el-tag type="success" size="medium" effect="dark">{{ result.data.order_no_price }}</el-tag>
             </p>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      option: [],
    };
  },
  methods: {
    ...mapActions({
      getStatisticalInfoAction: "getStatisticalInfoAction",
    }),

    // myEcharts() {
    //   // 基于准备好的dom，初始化echarts实例
    //   var myChart = this.$echarts.init(document.getElementById("main"));
    //
    //   // // 指定图表的配置项和数据
    //   // var option = {
    //   //   title: {
    //   //     text: "ECharts 入门示例",
    //   //   },
    //   //   tooltip: {},
    //   //   legend: {
    //   //     data: ["销量"],
    //   //   },
    //   //   xAxis: {
    //   //     data: ["代理商", "销售订单", "提现申请", "售后订单", "待结算", "待结算利润"],
    //   //   },
    //   //   yAxis: {},
    //   //   series: [
    //   //     {
    //   //       name: "销量",
    //   //       type: "bar",
    //   //       data: [5, 20, 36, 10, 10, 20],
    //   //     },
    //   //   ],
    //   // };
    //
    //   // 使用刚指定的配置项和数据显示图表。
    //   myChart.setOption(this.option);
    // },
  },
  created() {
    this.getStatisticalInfoAction({});
  },
  mounted() {},

  computed: {
    ...mapState({
      result: (state) => state.statistical.result,
    }),
  },
  watch: {
    // result(newdata) {
    //   this.option = {
    //     // title: {
    //     //   text: "销量",
    //     // },
    //     tooltip: {},
    //     legend: {
    //       // data: ["销量"],
    //     },
    //     xAxis: {
    //       data: ["代理商", "销售订单", "提现申请", "售后订单", "待结算", "待结算利润"],
    //     },
    //     yAxis: {},
    //     series: [
    //       {
    //         name: "销售概况",
    //         type: "bar",
    //         data: [
    //           newdata.data.agent_user_count,
    //           newdata.data.order_count,
    //           newdata.data.withdrawal_count,
    //           newdata.data.agent_orders_service_count,
    //
    //           newdata.data.order_no_count,
    //           newdata.data.order_no_price,
    //         ],
    //       },
    //     ],
    //   };
    //   this.myEcharts();
    // },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box-card {
  padding: 18px 0;
  margin-top: 20px;
  margin-right: 10px;
}
.item p {
  color: rgb(243, 8, 137);
}
.text-direction-center{
    text-align: center;
}
</style>
